"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STANDARD_CAMPAIGN_DELIVERY_POLICY = exports.DEFAULT_CAMPAIGN_CONNECTIVITY_THRESHOLD_PERCENTAGE = exports.CAMPAIGN_DELIVERY_POLICY_VERSION = void 0;
exports.CAMPAIGN_DELIVERY_POLICY_VERSION = 1;
exports.DEFAULT_CAMPAIGN_CONNECTIVITY_THRESHOLD_PERCENTAGE = 60;
exports.STANDARD_CAMPAIGN_DELIVERY_POLICY = {
    version: exports.CAMPAIGN_DELIVERY_POLICY_VERSION,
    mode: "standard",
    minimumConnectivityPercentage: exports.DEFAULT_CAMPAIGN_CONNECTIVITY_THRESHOLD_PERCENTAGE,
};
